import { render, staticRenderFns } from "./ChannelDetails.vue?vue&type=template&id=dc666534&scoped=true"
import script from "./ChannelDetails.vue?vue&type=script&lang=js"
export * from "./ChannelDetails.vue?vue&type=script&lang=js"
import style0 from "./ChannelDetails.vue?vue&type=style&index=0&id=dc666534&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc666534",
  null
  
)

export default component.exports